$(document).on('click', '.section-tabs__link', function () {
    $(".section-tabs__link").attr("aria-selected","false");
    $(this).attr("aria-selected","true");

    openTabpanel($(this));

    if ($(this).closest('.support-resources').length > 0) {
        let handle = $(this).attr('data-handle');
        if ($(`#Slider-${handle}`).length > 0) {
            $(`#Slider-${handle}`)[0].update();
        }
    }

    if ($(this).closest('.maintenance-tips').length > 0) {
        if(!elementIsVisibleInViewport($(this))) {
            $('.slider-tabs').animate({scrollLeft: $(this)[0].getBoundingClientRect().x}, 200);
        }
    }
});

$('.accordeon__title.faq').on('click', function () {
    $('.accordeon__title.faq').not($(this)).removeClass('active');
    $('.accordeon__title.faq').not($(this)).next().slideUp(300);

    $(this).toggleClass('active');
    $(this).next().slideToggle(300);
});

$(document).on('click', '.section-tabs__mobile-dropdown', function () {
    $(".section-tabs__mobile-dropdown").not(this).attr("aria-selected","false");

    if ($(this).attr('aria-selected') == 'true') {
        $(this).attr("aria-selected","false");
    } else {
        $(this).attr("aria-selected","true");
    }

    openTabpanelCollapse($(this));
});


function openTabpanel(element) {
    let tabpanelId = element.attr("aria-controls"),
        tabpanel = $("#"+tabpanelId);

    if (element.closest('.tabs-grid').hasClass('tabs-with-hash')) {
        let handleId = element.attr("data-handle");
        window.location.hash = handleId;
    }
    
    $(".tabs__section").attr("aria-hidden","true").fadeOut(500);
    tabpanel.attr("aria-hidden","false").fadeIn(500);
}
function openTabpanelCollapse(element) {
    let tabpanelId= element.attr("aria-controls"),
        tabpanel = $("#"+tabpanelId);

    $(".tabs__section").not(tabpanel).attr("aria-hidden","true").fadeOut(500);

    if (tabpanel.attr('aria-hidden') == 'false') {
        tabpanel.attr("aria-hidden","true").fadeOut(500);
    } else {
        tabpanel.attr("aria-hidden","false").fadeIn(500);
        scrollToSection("#dropdown-"+tabpanelId);
    }
}
function scrollToSection(hash) {
    let headerHeight = $('.header-mobile-section').height();
    $('html, body').animate({scrollTop: $(`${hash}`).offset().top - headerHeight }, 0);
}

function setInitialPanel() {
    var handle = window.location.hash;
    if (handle)  {
        handle = handle.replace('#', '');
        $('.section-tabs__link[data-handle="'+ handle +'"]').trigger('click');
    }
}

const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
    const { top, left, bottom, right } = el[0].getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return partiallyVisible
        ? ((top > 0 && top < innerHeight) ||
            (bottom > 0 && bottom < innerHeight)) &&
        ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
        : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};

document.addEventListener('DOMContentLoaded', setInitialPanel);